export default {"src":"/_next/static/media/StarEmptyDark.0ee19537.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};